/* assets/country-selector.js
   Drives the "Select your country" popup (snippets/country-selector-modal.liquid),
   opened by any [data-open-country-modal] button (the header/mobile-drawer trigger,
   snippets/country-selector.liquid). Vanilla JS, no dependency on theme.js/jQuery.

   Two things this deliberately works around:
   1. theme.js clones the header trigger into the mobile menu drawer with a plain
      .clone() — that copies the DOM node but NOT any event listeners attached to the
      original, and the clone may not even exist yet when this script runs. So the
      trigger is opened via event delegation on `document` (matching on click-time
      target), not a listener bound to each trigger element individually.
   2. The header (and Shopify's auto-generated section wrapper around it) can end up
      establishing its own CSS stacking context (e.g. via a sticky/animated header),
      which traps a `position: fixed` descendant's z-index below other page content
      even though it visually covers the viewport. To sidestep that entirely, the
      modal is moved to be a direct child of <body> on load — the standard "portal"
      pattern for modals — regardless of where it was originally rendered in the
      Liquid template. */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var modal = document.querySelector('[data-country-modal]');
    if (!modal) return;

    // Re-parent to <body> so no ancestor's stacking context / transform can trap it.
    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }

    var comboToggle = modal.querySelector('[data-country-combo-toggle]');
    var comboPanel = modal.querySelector('[data-country-combo-panel]');
    var comboFlag = modal.querySelector('[data-country-combo-flag]');
    var comboLabel = modal.querySelector('[data-country-combo-label]');
    var search = modal.querySelector('[data-country-search]');
    var options = modal.querySelectorAll('[data-country-option]');
    var hiddenInput = modal.querySelector('[data-country-modal-input]');
    var closers = modal.querySelectorAll('[data-country-modal-close]');
    var lastFocused = null;

    function openModal() {
      lastFocused = document.activeElement;
      modal.hidden = false;
      document.body.classList.add('country-modal-open');
      // If the mobile hamburger menu is open, close it so the popup isn't hidden behind it.
      document.body.classList.remove('reveal-mobile-nav');
      document.addEventListener('keydown', onKeydown);
      // The search box lives in the collapsed panel, so focus the visible country toggle.
      window.setTimeout(function () {
        comboToggle.focus();
      }, 0);
    }

    function closeModal() {
      modal.hidden = true;
      closeCombo();
      document.body.classList.remove('country-modal-open');
      document.removeEventListener('keydown', onKeydown);
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    }

    function closeCombo() {
      comboPanel.hidden = true;
      comboToggle.setAttribute('aria-expanded', 'false');
    }

    function onKeydown(evt) {
      if (evt.key === 'Escape' || evt.keyCode === 27) {
        // Close the open country list first; a second Escape closes the dialog.
        if (!comboPanel.hidden) {
          closeCombo();
          comboToggle.focus();
        } else {
          closeModal();
        }
        return;
      }
      if (evt.key === 'Tab' || evt.keyCode === 9) trapFocus(evt);
    }

    // aria-modal="true" promises focus stays in the dialog, so wrap Tab at both ends.
    function trapFocus(evt) {
      var focusable = Array.prototype.filter.call(
        modal.querySelectorAll('button, input:not([type="hidden"]), [href], [tabindex]:not([tabindex="-1"])'),
        function (el) { return !el.disabled && el.offsetParent !== null; }
      );
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (evt.shiftKey && (document.activeElement === first || !modal.contains(document.activeElement))) {
        evt.preventDefault();
        last.focus();
      } else if (!evt.shiftKey && (document.activeElement === last || !modal.contains(document.activeElement))) {
        evt.preventDefault();
        first.focus();
      }
    }

    // Delegated: catches the desktop trigger AND the mobile-drawer clone (made by
    // theme.js after this script has already run, with no listeners of its own).
    document.addEventListener('click', function (evt) {
      if (evt.target.closest && evt.target.closest('[data-open-country-modal]')) {
        openModal();
      }
    });

    closers.forEach(function (el) {
      el.addEventListener('click', closeModal);
    });

    comboToggle.addEventListener('click', function () {
      var expanded = comboToggle.getAttribute('aria-expanded') === 'true';
      comboToggle.setAttribute('aria-expanded', String(!expanded));
      comboPanel.hidden = expanded;
      if (!expanded) {
        if (search) {
          search.value = '';
          filterList('');
        }
        window.setTimeout(function () {
          if (search) search.focus();
        }, 0);
      }
    });

    if (search) {
      search.addEventListener('input', function () {
        filterList(search.value);
      });
    }

    function filterList(term) {
      term = term.trim().toLowerCase();
      options.forEach(function (li) {
        var haystack = li.getAttribute('data-search') || '';
        li.hidden = haystack.indexOf(term) === -1;
      });
    }

    options.forEach(function (li) {
      var btn = li.querySelector('[data-value]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var code = btn.getAttribute('data-value');
        hiddenInput.value = code;
        comboFlag.src = btn.getAttribute('data-flag');
        comboLabel.textContent = btn.getAttribute('data-name') + ' (' + btn.getAttribute('data-currency') + ')';
        options.forEach(function (other) {
          var otherBtn = other.querySelector('[data-value]');
          if (otherBtn) otherBtn.setAttribute('aria-pressed', String(otherBtn === btn));
        });
        closeCombo();
        // The focused option is now hidden; return focus to the toggle, which announces the new choice.
        comboToggle.focus();
      });
    });
  });
})();